module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-MR.f7134c89.png";